import '@shui/core/sh-table';

import { Component, booleanAttribute, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-table-row',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.freeze]': 'freeze() ? "" : null',
        '[attr.label-rows]': 'labelRows() ?? null',
        '[attr.readonly]': 'readonly() ? "" : null',
        '(active-changed)': 'activeChangedEvent.emit($event)',
        '(clicked)': 'rowClicked.emit($event)',
        '(collapse)': 'collapsed.emit($event)',
        '(expand)': 'expanded.emit($event)'
    }
})
export class ShTableRowComponent {
    /** Applies condensed row spacing. */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /**
     * Adds frozen-left, scrollable, and frozen-right slots to the DOM.
     * Every row in a frozen table must set this to `true`.
     */
    public readonly freeze = input(false, { transform: booleanAttribute });

    /**
     * Number of rows to use for header labels in this row.
     * Accepts a positive integer or `'auto'`.
     */
    public readonly labelRows = input<string | undefined>(undefined);

    /** Removes hover and active states from this row. */
    public readonly readonly = input(false, { transform: booleanAttribute });

    /** Emitted when the active state of the row changes. */
    public readonly activeChangedEvent = output<Event>();

    /** Emitted when the row is clicked. */
    public readonly rowClicked = output<Event>();

    /** Emitted when the row enters a collapsed state. */
    public readonly collapsed = output<Event>();

    /** Emitted when the row enters an expanded state. */
    public readonly expanded = output<Event>();
}
